const certs = [
  {
    icon: "ri-government-line",
    title: "Trade License",
    issuer: "Government of West Bengal",
    description: "Legally authorized trading entity registered under Indian business law.",
    badge: "VERIFIED"
  },
  {
    icon: "ri-file-text-line",
    title: "Export Compliance",
    issuer: "DGFT & APEDA Standards",
    description: "Adherence to all export compliance standards and international trade regulations.",
    badge: "CERTIFIED"
  }
];

export default function Certifications() {
  return (
    <section id="certifications" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4">
            Trust &amp; Compliance
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Certifications &amp; Compliance
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            We operate with full legal compliance and uphold the highest standards of trade integrity.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-6 max-w-2xl mx-auto">
          {certs.map((cert, i) => (
            <div
              key={i}
              className="flex-1 relative bg-white border-2 border-[#1B4332]/10 hover:border-[#C9A227] rounded-2xl p-8 text-center transition-all duration-300 hover:shadow-lg cursor-default group"
            >
              {/* Badge */}
              <span className="absolute top-4 right-4 text-xs font-bold bg-[#D8F3DC] text-[#2D6A4F] px-2.5 py-0.5 rounded-full">
                {cert.badge}
              </span>
              {/* Icon circle */}
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-[#1B4332] text-[#C9A227] mx-auto mb-5 group-hover:scale-110 transition-transform duration-300">
                <span className="text-3xl">
                  <i className={cert.icon}></i>
                </span>
              </div>
              <h3 className="text-lg font-bold text-[#1B4332] mb-1">{cert.title}</h3>
              <p className="text-xs text-[#C9A227] font-semibold mb-3">{cert.issuer}</p>
              <p className="text-sm text-gray-500 leading-relaxed">{cert.description}</p>
              {/* Decorative gold line */}
              <div className="mt-5 mx-auto w-12 h-1 bg-[#C9A227] rounded-full"></div>
            </div>
          ))}
        </div>

        {/* Trust Banner */}
        <div className="mt-14 bg-gradient-to-r from-[#1B4332] to-[#2D6A4F] rounded-2xl p-8 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-8 text-center md:text-left">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#C9A227] text-white flex-shrink-0 mx-auto md:mx-0">
              <span className="text-3xl">
                <i className="ri-handshake-line"></i>
              </span>
            </div>
            <div className="flex-1">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                Your Trusted Export Partner from India
              </h3>
              <p className="text-white/70 text-sm leading-relaxed">
                Pandit Export is committed to transparent business practices, legal compliance, and building long-term relationships with global buyers. Every transaction is backed by proper documentation and professional service.
              </p>
            </div>
            <button
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              className="flex-shrink-0 bg-[#C9A227] hover:bg-[#b8911e] text-white font-bold px-6 py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Work With Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
